import { createAction, props } from '@ngrx/store';

import { Session } from '@lockton-apps/shared/interfaces';

export enum AuthActionTypes {
  Init = '[Auth/Page] Init',
  InitSuccess = '[Auth/Page] Init Success',
  InitFailure = '[Auth/Page] Init Failure',

  RefreshToken = '[Auth/Page] Refresh Token',
  RefreshTokenSuccess = '[Auth/API] Refresh Token Success',
  RefreshTokenFailure = '[Auth/API] Refresh Token Failure',

  Logout = '[Auth/Page] Logout',
  LogoutSuccess = '[Auth/API] Logout Success',
  LogoutFailure = '[Auth/API] Logout Failure',

  TimeoutWarning = '[Auth/UserIdle] Timeout Warning',

  SessionTerminated = '[Auth/Page] Session Terminated',

  // #TODO Rework!
  AuthenticateSession = '[Auth/Page] Authenticate Session',
  SetContactType = '[Auth/Page] Set Contact Type',
}

export const init = createAction(AuthActionTypes.Init);

export const initSuccess = createAction(
  AuthActionTypes.InitSuccess,
  props<{ session: Session }>()
);

export const initFailure = createAction(AuthActionTypes.InitFailure);

export const refreshToken = createAction(AuthActionTypes.RefreshToken);

export const refreshTokenSuccess = createAction(
  AuthActionTypes.RefreshTokenSuccess,
  props<{ token: string }>()
);

export const refreshTokenFailure = createAction(
  AuthActionTypes.RefreshTokenFailure,
  props<{ message: string }>()
);

export const timeoutWarning = createAction(AuthActionTypes.TimeoutWarning);

export const sessionTerminated = createAction(
  AuthActionTypes.SessionTerminated
);

export const logout = createAction(AuthActionTypes.Logout);

export const logoutSuccess = createAction(AuthActionTypes.LogoutSuccess);

export const logoutFailure = createAction(
  AuthActionTypes.LogoutFailure,
  props<{ message: string }>()
);
export const authenticateSession = createAction(
  AuthActionTypes.AuthenticateSession,
  props<{ session: Session }>()
);
